export default (axios) => ({
  fetchPoints(payload) {
    return axios.post(`/consultant/coupon/value`,payload);
  },
  fetchOffers(payload) {
    return axios.post("/offer/get", payload);
  },
  ApplyOffer(payload) {
    return axios.post(`/offer/apply`, payload);
  },
  createOrder(payload) {
    return axios.post(`/order`,payload);
  },
});